// PROSPECT_GENERAL_ERROR
// PROSPECT_YOUNG
// PROSPECT_REG_ALREADY_EXIST
// PROSPECT_ALREADY_EXIST
// PROSPECT_INVALID_PERSONAL_ID
// PROSPECT_INVALID_PHONE
// PROSPECT_INVALID_EMAIL
// PROSPECT_INVALID_LOGNAME
// PROSPECT_LOGNAME_ALREADY_EXIST
// PROSPECT_RESEND_BANNED

import React from 'react';
import { clearPersistentError, clearSubmitting, makeError, setPersistentError } from 'nike-form-js';
import { fromJS, Map } from 'immutable';
import { getConfig } from './config';
import i18n from '../../../common/i18n';
import NegativeIcon from '../../../icons/NegativeIcon';
import { Button } from '../../button/Button';
import './error.less';

function isClientError(code) {
    return (
        code === 'PROSPECT_REG_ALREADY_EXIST_EMAIL' ||
        code === 'PROSPECT_REG_ALREADY_EXIST_PHONE' ||
        code === 'PROSPECT_ALREADY_EXIST_EMAIL' ||
        code === 'PROSPECT_ALREADY_EXIST_PHONE' ||
        code === 'PROSPECT_RESEND_BANNED' ||
        code === 'PROSPECT_SMS_SEND_FORBIDDEN' ||
        code === 'PROSPECT_PHONE_CHANGE_FORBIDDEN' ||
        code === 'PROSPECT_VERIFICATION_FAILED_OLD_CODE' ||
        code === 'PROSPECT_LOGNAME_ALREADY_EXIST' ||
        code === 'PROSPECT_INVALID_LOGNAME' ||
        code === 'LOGNAME_DUPLICATE' ||
        code === 'CLIENT_PENDING_DOCUMENTS' ||
        code === 'PERSONAL_ID_DUPLICATE' ||
        // zmena hesla
        code === 'PASSWORD_OLD_WRONG' ||
        code === 'PASSWORD_REPEAT' ||
        code === 'USER_IN_IRVO'
    );
}

function wrapError(payload) {
    if (payload?.type === 'rest_error') {
        return {
            clientError: isClientError(payload.code),
            code: payload.code,
            message: payload.message,
            i18nMessage: i18n('nui.registration.clienterror.' + payload.code)
        };
    }
    return {
        clientError: false,
        code: 'GENERAL'
    };
}

// toto je dost naivny check, ale nemam lepsi
function isNikeForm(maybeForm) {
    return maybeForm && maybeForm._type === 'ra';
}

const defaultErrorConfig = {
    codeHandlers: null,
    uiWrapper: wrapError,
    finalHandler: error => getConfig().onError(error)
};

export function handleServerErrors(uiComponent, config) {
    const c = Object.assign({}, defaultErrorConfig, config);
    return error => {
        const payload = error?.response?.data;
        if (isNikeForm(uiComponent)) {
            const form = uiComponent;
            clearSubmitting(form);
            clearPersistentError(form);
            if (payload?.type === 'form_error') {
                setPersistentError(
                    form,
                    fromJS(payload.fieldErrors).reduce((acc, key, path) => acc.set(path, makeError([i18n(key)])), Map())
                );
                return Promise.resolve();
            }
            if (c.codeHandlers && payload?.code && c.codeHandlers[payload.code]) {
                const handler = c.codeHandlers[payload.code];
                return handler(form);
            }
        }
        if (uiComponent?.setBlocking) {
            uiComponent.setBlocking(false);
        }

        const uiError = c.uiWrapper(payload);
        if (uiError?.clientError) {
            return getConfig().open('ERROR', { uiError });
        }
        return c.finalHandler(error);
    };
}

export function persistentHandler(path, errorKey) {
    return form => setPersistentError(form, fromJS({ [path]: makeError([i18n(errorKey)]) }));
}

export function DialogErrorBody({ uiError, close }) {
    return (
        <div className={'dialog-registration-error'} data-code={uiError.code}>
            <NegativeIcon width={70} height={70} />
            <p className={'error-text'} dangerouslySetInnerHTML={{ __html: uiError.i18nMessage }} />
            <div className={'nui-input p-rel mb-20 flex flex-col confirm-button'}>
                <Button primary large onClick={() => close()} label={i18n('nui.button.close')} />
            </div>
        </div>
    );
}
